import { FC } from 'react';
import { NavLink, useLocation } from 'react-router';
import { ProfileMenuItem } from '../config';
import { useRoute } from 'src/router/hooks/useRoute';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export const Link: FC<ProfileMenuItem> = ({ route, content, Icon, onClick }) => {
  const { ROUTE } = useRoute();
  const { t } = useTranslation();
  const location = useLocation();
  const isCurrentLocation = location.pathname.includes(route);

  return (
    <NavLink
      onClick={onClick}
      to={ROUTE.CUSTOM.get(route)}
      className="w-full flex justify-start items-center px-1 gap-2.5 group">
      <Icon
        fill={isCurrentLocation ? 'var(--text_active_sidebar)' : ''}
        className="group-hover:[&_path]:fill-text_active_sidebar w-6 h-6"
      />
      <p
        className={classNames(
          isCurrentLocation ? 'text-text_active_sidebar' : 'text-text_primary_sidebar',
          'flex-1 text-left font-bold text-base group-hover:text-text_active_sidebar'
        )}>
        {t(content)}
      </p>
    </NavLink>
  );
};
